import { UserRole } from '@upstart/harmony/lib/constants';
import { get } from 'lodash';

const MenuItems = [
  {
    name: 'Feeds',
    url: '/feeds',
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.READ_ONLY_ADMIN],
  },
  {
    name: 'Mappings',
    url: '/feedMappings',
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.READ_ONLY_ADMIN],
  },
];

const hasAnyOfRole =
  (user) =>
  ({ roles }) => {
    const userRoles = get(user, 'roles', []);
    return userRoles.some((role) => roles.includes(role));
  };

export default (user) => MenuItems.filter(hasAnyOfRole(user));
